import { render, staticRenderFns } from "./MessageItemAttachmentAudio.vue?vue&type=template&id=8a6fdb56&scoped=true&"
import script from "./MessageItemAttachmentAudio.vue?vue&type=script&lang=ts&"
export * from "./MessageItemAttachmentAudio.vue?vue&type=script&lang=ts&"
import style0 from "./MessageItemAttachmentAudio.vue?vue&type=style&index=0&id=8a6fdb56&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a6fdb56",
  null
  
)

export default component.exports